import { Injectable } from '@angular/core';
import { TemplatesRepository } from '@core/repositories/templates.repository';
import { Template } from '@shared/interfaces/template';
import { Observable, of } from 'rxjs';

interface ResultTemplate {
  id: string;
  attributes: {
    name: string;
    value: string;
  };
  relationships: {
    type: {
      id: string;
      name: string;
    };
  };
}

@Injectable({ providedIn: 'root' })
export class FakeTemplatesRepository implements TemplatesRepository {
  url: string;

  dataTemplates: Array<ResultTemplate> = [
    {
      id: '301',
      attributes: {
        name: 'Enviar',
        value: 'data data data data data data data data data data data data data data'
      },
      relationships:
      {
        type: {
          id: '1',
          name: 'Enviar'
        }
      }
    },
    {
      id: '401',
      attributes: {
        name: 'Cancelar',
        value: 'data'
      },
      relationships:
      {
        type: {
          id: '2',
          name: 'Cancelar'
        }
      }
    },
    {
      id: '501',
      attributes: {
        name: 'Pagar',
        value: 'data'
      },
      relationships:
      {
        type: {
          id: '3',
          name: 'Pagar'
        }
      }
    }
  ];

  templates = {
    data: this.dataTemplates
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.templates);
  }

  add(template: Template): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(template: Template): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
